import { skipToken, useQuery } from '@tanstack/react-query';

import { Workspaces } from '@air/api';
import { type Asset, type Workspace } from '@air/api/types';
import { callAirApi } from '@air/utils-api';

export const CDN_LINKS_LIST_KEY = '@plugin-ui/CDN_LINKS_LIST';

export const getCdnLinksListKey = (params: UseListCdnLinksParams) => {
  return [CDN_LINKS_LIST_KEY, params];
};

export type UseListCdnLinksParams = {
  workspaceId: Workspace['id'] | undefined;
  assetId: Asset['id'] | undefined;
  followsDefaultVersion?: boolean;
};

export const useListCdnLinks = (params: UseListCdnLinksParams) => {
  const { assetId, workspaceId } = params;

  return useQuery({
    queryFn:
      workspaceId && assetId
        ? () =>
            callAirApi(() =>
              Workspaces.CdnLinks.list({
                assetId,
                followsDefaultVersion: params.followsDefaultVersion,
                workspaceId,
              }),
            )
        : skipToken,
    queryKey: getCdnLinksListKey(params),
  });
};
